import RegionInfoStore from '../stores/RegionInfoStore';

export default  new RegionInfoStore();


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/storeInstances/regionStore.ts